export const MARKETS_DETAILS_HEIGHT_DESKTOP = 50
export const TRADE_PANEL_HEIGHT_DESKTOP = 40
export const TRADE_PANEL_WIDTH_MD = 330
export const TRADE_PANEL_WIDTH_LG = 300
export const MARKET_DROPDOWN_WIDTH = 170
export const USER_INFO_PANEL_HEIGHT = 32
export const USER_INFO_FILTERS_HEIGHT = 45
export const DEFAULT_TABLE_PAGE_SIZE = 10
